import React from 'react';
import { instanceOf, func, bool } from 'prop-types';
import { connect } from 'react-redux';
import { removeSelectedTc } from '../../../actions/turnkeyOmnibusActions';

const SelectionItem = ({ item, removeSelectedTc, loading }) => {
  const { qTitle, title } = item;

  return (
    <div className="ie--target--selections--item" style={{ opacity: loading ? 0.5 : 1 }}>
      <span className="ie--target--selections--text">{`${qTitle} -- ${title}`}</span>
      <button
        type="button"
        title="Remove selection"
        onClick={() => removeSelectedTc(item)}
        className="ie--target--selections--remove"
        disabled={loading}
      >
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        </svg>
      </button>
    </div>
  );
};

SelectionItem.propTypes = {
  item: instanceOf(Object),
  removeSelectedTc: func,
  loading: bool,
};

SelectionItem.defaultProp = {
  item: {},
  loading: false,
};

export default connect(
  null,
  { removeSelectedTc }
)(SelectionItem);
